export default "__VITE_ASSET__CJFBbnpi__"